import { CSSTransition, TransitionGroup } from 'react-transition-group';
import React, { useEffect } from 'react';
import { Toast, withStyles } from '@kaboodle-solutions/design-system';

import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getToastMessages } from '../../selectors/messages';
import { messageOperations } from '../../store/messages';
import styles from './ToastOverlay.styles';
import useMessageQueue from '../../hooks/useMessageQueue';

const ToastOverlay = ({ classes, messages, actionMessage }) => {
  const { messageQueue, addMessage } = useMessageQueue([]);

  useEffect(() => {
    // initialise and add the messages to the queue
    // ignore if actioned or in message queue already to prevent infinite addition
    messages
      .filter(
        ({ actioned, id }) =>
          !actioned && !messageQueue.find(msg => msg.id === id),
      )
      .forEach(message => addMessage(message));
  }, [messageQueue, messages, addMessage]);

  useEffect(() => {
    // clear the message action status in redux after the message has been displayed
    if (messageQueue.length === 0) {
      messages
        .filter(({ actioned }) => !actioned)
        .forEach(message => actionMessage(message.id));
    }
  }, [messageQueue, messages]);

  return (
    <TransitionGroup className={classes.overlay}>
      {messageQueue.map(message => (
        <CSSTransition
          key={message.id}
          timeout={200}
          classNames={classes.toast}>
          <Toast type={message.type}>
            {Array.isArray(message.message) && message.message?.length
              ? message.message.map(msg => (
                  <span key={msg}>
                    {msg} <br />
                  </span>
                ))
              : message.message}
          </Toast>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
};

ToastOverlay.propTypes = {
  actionMessage: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    overlay: PropTypes.string,
    toast: PropTypes.string,
  }),
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      displayType: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      message: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string.isRequired,
      ]),
      actioned: PropTypes.bool.isRequired,
      required: PropTypes.bool.isRequired,
    }),
  ),
};

ToastOverlay.defaultProps = {
  classes: {},
  messages: [],
};

const mapStateToProps = state => ({
  messages: getToastMessages(state),
});

const mapDispatchToProps = {
  actionMessage: messageOperations.actionMessage,
};

export { ToastOverlay, mapStateToProps };

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(ToastOverlay);
